import React, { useEffect, Suspense, lazy } from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { theme } from './theme';
import AppRouterWithI18n from './AppRouter';
import ErrorBoundary from './ErrorBoundary';
import { AlertProvider } from './components/alertProvider';
import { LoaderProvider } from './components/loaderProvider/loader';
import { ClinicProvider } from './components/ClinicProvider';
import { MultilingualProvider } from './components/multilingualProvider';
import { I18nextProvider } from 'react-i18next';
import i18n from './services/i18n';
import { PrintProvider } from './components/PrintProvider';
import DefaultLoader from './components/defaultLoader';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';

const LazyProviders = lazy(() => import('./components/LazyProviders'));
const queryClient = new QueryClient();
const App: React.FC = () => {

  useEffect(() => {
    // Apply the linear gradient to the body dynamically
    document.body.style.background = 
      'linear-gradient(72deg, #FFF 0%, #FFF 9.67%, #F6F6F6 32.14%, #ECEEF0 100%), ' +
      'linear-gradient(72deg, #FFF 0%, #FFF 9.67%, #F6F6F6 32.14%, #ECEEF0 100%)';
    
    document.body.style.backgroundSize = 'cover';  // Ensure the gradient covers the full screen

    // Optional cleanup function to reset background on component unmount
    return () => {
      document.body.style.background = '';
    };
  }, []);  // O
  
  return (
    <>
      <ToastContainer
        position='top-right'
        autoClose={2000}
        hideProgressBar
        closeButton={false}
        newestOnTop
        draggable={false}
        pauseOnHover
      />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ErrorBoundary>
          <QueryClientProvider client={queryClient}>
            <I18nextProvider i18n={i18n}>
              <MultilingualProvider language="en"> {/* Set default language here */}
                <PrintProvider>
                  <ClinicProvider>
                    <AlertProvider>
                      <LoaderProvider>
                        <Suspense fallback={<DefaultLoader />}>
                          <LazyProviders>
                            <AppRouterWithI18n /> {/* Routes are rendered here */}
                          </LazyProviders>
                        </Suspense>
                      </LoaderProvider>
                    </AlertProvider>
                  </ClinicProvider>
                </PrintProvider>
              </MultilingualProvider>
            </I18nextProvider>
          </QueryClientProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </>
  );
};

export default App;